import React, { useState, useEffect } from 'react'
import { Flex, Image, Box } from '@chatterbug/aaron'
import { t } from 'src/lib/i18n-react'

import blocked from './assets/blocked.svg'
import heartSpray from './assets/heart_spray.svg'

import InteractiveHeart from '../InteractiveHeart/InteractiveHeart'

export type Props = {
  isFavorite: boolean
  isBlocked: boolean
  name: string
  login: string
  onChangeTutorRating: (login: string, newValue: boolean) => any
  onOrderChange: (login: string, newValue: boolean) => any
}

const TutorRatingIcon: React.FC<Props> = ({
  isFavorite,
  isBlocked,
  name,
  onChangeTutorRating,
  login,
  onOrderChange,
}) => {
  const [hovered, setHovered] = useState(false)
  const [isHeartRed, setIsHeartRed] = useState(isFavorite)
  const [iconOpacity, setIconOpacity] = useState(0)

  useEffect(() => {
    setIsHeartRed(isFavorite)
  }, [login, isFavorite])

  if (isBlocked) {
    return (
      <Flex mt="0,5x">
        <Image
          src={blocked}
          data-testid="tutor-rating"
          alt={t('Tutor Blocked')}
          title={t('Tutor Blocked')}
        />
      </Flex>
    )
  }
  return (
    <Flex
      borderRadius="100%"
      width={32}
      height={32}
      justifyContent="center"
      sx={{
        ':hover': {
          backgroundColor: 'pink97',
          cursor: 'pointer',
        },
      }}
      onMouseOver={() => setHovered(true)}
      onMouseOut={() => setHovered(false)}
    >
      <Box
        as="button"
        aria-pressed={isHeartRed}
        aria-label={
          isHeartRed
            ? t('click to unfavorite %{name}', { name })
            : t('click to favorite %{name}', { name })
        }
        position="relative"
        mt="0,5x"
        sx={{
          border: 0,
          padding: 0,
          backgroundColor: 'transparent',
          outline: 'none',
        }}
        onClick={async () => {
          if (isFavorite) {
            // unFavoriting
            setIsHeartRed(false)
            try {
              await onChangeTutorRating(login, false)
              // to reorder after the animation is completed
              onOrderChange(login, false)
            } catch {
              // if mutation failed, revert state
              setIsHeartRed(true)
            }
          } else {
            // Favoriting
            setIsHeartRed(true)
            setIconOpacity(1)
            window.setTimeout(() => {
              setIconOpacity(0)
            }, 500)

            try {
              await onChangeTutorRating(login, true)
              window.setTimeout(() => {
                onOrderChange(login, true)
              }, 400)
            } catch {
              setIsHeartRed(false)
            }
          }
        }}
        data-testid="tutor-rating"
      >
        <InteractiveHeart hovered={hovered} isHeartRed={isHeartRed} />
        {/* spray animation */}
        <Box
          sx={{
            position: 'absolute',
            right: '-7px',
            top: '-7px',
            width: '12px',
            height: '13px',
            backgroundImage: `url(${heartSpray})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            transition: 'opacity 0.3s ease, transform 0.3s ease',
            opacity: iconOpacity,
            transform: `scale(${iconOpacity})`,
          }}
        />
      </Box>
    </Flex>
  )
}

export default TutorRatingIcon
